import queryString from 'query-string';
import React, { Component, Fragment } from 'react';
import { ReactComponent as Minus } from '../../../assets/screen10/Minus.svg';
import style from '../../game10/style.module.scss';
import GameHeader from '../../GameHeader';
import Toolpit from '../../HelpPopUp';
import Modal from '../../ModalDeleteVacancy';
import PageWrapper from '../../PageWrapper';
import { Game10 as Game10Mock } from './mock';
import { withTranslation } from 'react-i18next';
import { createRetakeTestRound } from '../utils/retakeTestRound';

class Game10 extends Component {
  state = {
    round: 0,
    hasCompletedRound: false,
    selectedItem: null,
    tap: false,
    isChecked: false,
    end: false,
  };

  componentDidMount() {
    this.setState({ data: Game10Mock.games });
    // Initialize the retake function
    this.retakeTestRound = createRetakeTestRound(this, 10, Game10Mock.games);
  }

  stopGameHandler = () => {
    this.setState({ openStopModal: true });
  };

  continueGameModal = () => {
    this.setState({ openStopModal: false });
  };

  onCloseGameModal = () => {
    const { history, match } = this.props;
    const testId = queryString.parse(this.props.location.search)['test'];

    history.push(`/game-info/10${match.params.id}?test=${testId}`);
  };

  getNextRound = () => {
    const { round, data, isChecked } = this.state;
    if (round < Object.keys(data).length - 1 && isChecked) {
      this.setState({ round: round + 1, tap: false, isChecked: false });
    } else if (round === Object.keys(data).length - 1) {
      this.setState({ tap: false, isChecked: false });
    }
  };
  startGameNew = () => {
    const { history, match } = this.props;
    const testId = queryString.parse(this.props.location.search)['test'];

    history.replace(`/game/10${match.params.id}?test=${testId}`);
  };

  addCheckedStyle = (index) => {
    const { isChecked } = this.state;
    if (index === isChecked) {
      return `${style.isChecked} ${style.active} ${style.isCheckedExample}`;
    } else {
      return `${style.isChecked} ${style.isCheckedExample}`;
    }
  };

  checkItem = (index, selectedItem) => {
    const { isChecked, end, round, data } = this.state;
    if (round === Object.keys(data).length - 1) {
      this.setState({ end: true, hasCompletedRound: true });
    }
    if (!isChecked && !end) {
      const newFlag = isChecked === index ? false : index;
      this.setState({ isChecked: newFlag, selectedItem, tap: true });
    }
  };

  render() {
    const { data, round, openStopModal, tap, selectedItem, end, isChecked } =
      this.state;
    const { history, t } = this.props;
    if (!data) {
      return <h1>{t('Loading')}</h1>;
    }

    return (
      <Fragment>
        {openStopModal && (
          <Modal
            onCancel={this.continueGameModal}
            onDelete={this.onCloseGameModal}
            text={t(
              'Are you sure want to end game? Once you exit you cannot restart the game',
            )}
            bntCancel={t('Cancel')}
            btnSuccess={t('End game')}
          />
        )}
        <PageWrapper isDashboardHeader history={history} isDashboardFooter>
          <div className="w-100 mb-5">
            <GameHeader
              stopGameHandler={this.stopGameHandler}
              currentTask={round + 1}
              allTask={Object.keys(data).length}
              timerSeconds={null}
              canForceEnd={false}
              gameType={t('Practice Run', { title: t('Shapes') })}
            />
            <div className={style.gameTaskWrapper}>
              <div className={style.gameTask}>
                <p className={style.gameDescription}>
                  {t(
                    'Subtract or add the parts then tap on the correct shape below',
                  )}
                </p>
                <div className={style.taskWrapper}>
                  <img
                    className={style.mainImage}
                    src={data[round].main_image_left.path}
                    alt=""
                  />
                  <div className={style.minusWrapper}>
                    {data[round].operation === 'minus' ? (
                      <Minus className={style.minus} />
                    ) : (
                      <i className="fas fa-plus"></i>
                    )}
                  </div>
                  <img
                    className={style.mainImage}
                    src={data[round].main_image_right.path}
                    alt=""
                  />
                </div>
              </div>
              <div className={style.answerList}>
                {data[round].options.map((el, index) => (
                  <div
                    key={index}
                    onClick={() => this.checkItem(index + 1, el)}
                    className={style.answerItem}
                  >
                    <img src={el.path} alt="" />
                    <div className={this.addCheckedStyle(index + 1)}>
                      <div className="selectedItemTestGames shapes">
                        <i className="fas fa-check"></i>
                      </div>
                    </div>
                    {tap &&
                      selectedItem &&
                      selectedItem.id === el.id &&
                      data[round].answer !== selectedItem.id && (
                        <div
                          className={`selectedItemTestGames shapes ${
                            data[round].answer === selectedItem.id
                              ? ''
                              : 'incorrect'
                          }`}
                        >
                          {data[round].answer === selectedItem.id &&
                          data[round].answer !== selectedItem.id ? (
                            <i className="fas fa-check"></i>
                          ) : (
                            <i className="fas fa-times"></i>
                          )}
                        </div>
                      )}
                    {tap &&
                      selectedItem &&
                      data[round].answer !== selectedItem.id &&
                      el.id === data[round].answer && (
                        <div className="selectedItemTestGames shapes">
                          <i className="fas fa-check"></i>
                        </div>
                      )}
                  </div>
                ))}
                {isChecked ? (
                  <Toolpit
                    status={
                      selectedItem && data[round].answer === selectedItem.id
                    }
                    game={'Shapes'}
                  />
                ) : null}
              </div>
            </div>
            <div className="d-flex justify-content-center">
              {!end ? (
                <button
                  disabled={end}
                  className={
                    !isChecked || end
                      ? `${style.buttonNext} ${style.disabledBtn}`
                      : style.buttonNext
                  }
                  onClick={this.getNextRound}
                >
                  {t('Next')}
                </button>
              ) : null}
              {end && (
                <div className="d-flex">
                  <button
                    disabled={!end}
                    className={style.buttonNext}
                    onClick={this.startGameNew}
                  >
                    {t('Start Assessment')}
                  </button>
                  {this.state.hasCompletedRound && (
                    <button
                      disabled={!end}
                      className={style.buttonNext}
                      style={{ margin: '25px 10px' }}
                      onClick={this.retakeTestRound}
                    >
                      {t('Redo Practice')}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </PageWrapper>
      </Fragment>
    );
  }
}

export default withTranslation()(Game10);
